<template>
  <Row>
    <Col span="6" offset="9">
      <Alert type="error" v-if="model.errorStr">{{ model.errorStr }}</Alert>
    <Form ref="form" :model="model" :rules="ruleValidate">
      <Form-item prop="username">
        <Input prefix="ios-contact" element-id="username" type="text" v-model="model.username" placeholder="请输入用户名或邮箱、手机号">
        </Input>
      </Form-item>
      <Form-item prop="password">
        <Input prefix="ios-key" element-id="password" type="password" v-model="model.password" placeholder="请输入密码">
        </Input>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSubmit('form')" long>登录</Button>
      </Form-item>
      <div class="prompt-msg">
        忘记密码？请
        <router-link to="/reset-password">找回密码</router-link>
      </div>
    </Form>
    </Col>
  </Row>
</template>

<script>
import { AccountLogin } from '@/api/sys.login'
import { FetchAuth } from '@/api/auth'

export default {
  name: 'signin',
  data: function () {
    return {
      model: {
        username: '',
        password: '',
        errorStr: ''
      },
      ruleValidate: {
        username: [
          { required: true, message: '用户名或邮箱或手机号码不能为空', trigger: 'change' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('登录信息填写有误!')
        }
      })
    },
    postForm: function () {
      AccountLogin(this.model).then(async res => {
        this.model.errorStr = res.error
        if (res.token) {
          this.$store.commit('storeToken', { token: res.token })
          this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
          this.$store.commit('refresh')
          this.fecthAuth()
          this.redirect()
        } else {
          this.$Message.error(res.error)
        }
      })
    },
    redirect: function () {
      var redirect = this.$route.query.redirect
      if (!redirect) {
        redirect = '/dashboard'
      }
      this.$router.push(redirect)
    },
    fecthAuth: function () {
      FetchAuth().then(async res => {
        this.$store.dispatch('refreshAuth', res)
      })
    }
  }
}
</script>

<style>
.prompt-msg {
  text-align: center;
}
</style>
